import React, { useEffect, useState, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import Header2 from "../../header2/index-two";
import InstructorSidebar from "../sidebar";
import { AppContext } from "../../../services/AuthContext";
import { ListByPublisherid } from "../../../services/userpanelservice";

// ORCID yakalayıcı (hem çıplak id hem tam URL kabul)
const ORCID_RE = /^(?:https?:\/\/orcid\.org\/)?(\d{4}-\d{4}-\d{4}-\d{3}[\dX])$/i;
const normalizeOrcid = (raw) => {
  if (!raw) return "";
  const m = String(raw).trim().match(ORCID_RE);
  return m ? m[1] : "";
};

const AuthorsPublisher = () => {
  const { auth } = useContext(AppContext);
  const { id } = useParams();
  const [authors, setAuthors] = useState([]);

  const fetchAuthors = async () => {
    try {
      const data = await ListByPublisherid(id, 0, 10, auth.token);
      if (data?.status === "OK") setAuthors(parseAuthorData(data.data));
      else setAuthors([]);
    } catch (e) {
      console.error("Error fetching publishers:", e);
      setAuthors([]);
    }
  };

  const parseAuthorData = (rows) =>
    (rows || []).map((item) => {
      const name =
        `${item.title || ""} ${item.name || ""} ${item.surname || ""}`
          .replace(/\s+/g, " ")
          .trim() || "-";
      const orcid = normalizeOrcid(item.orcid);
      return {
        id: item.id,
        name,
        orcid, // boş olabilir
      };
    });

  useEffect(() => {
    fetchAuthors();

  }, [id]);

  return (
    <div className="main-wrapper mt-5">
      <Header2 />
      <div className="page-content">
        <div className="container">
          <div className="row">
            <InstructorSidebar />
            <div className="col-xl-9 col-lg-9">
              <div className="settings-widget card-details">
                <div className="settings-menu p-0">
                  <div className="profile-heading">
                    <h3>Yazar Bilgileri</h3>
                  </div>

                  <div className="instructor-course-table">
                    <div className="table-responsive custom-table">
                      <table className="table mb-0">
                        <thead>
                          <tr>
                            <th>Yazar Adı</th>
                            <th style={{ width: 240 }}>ORCID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {authors.length ? (
                            authors.map((a) => (
                              <tr key={a.id}>
                                <td>
                                  <Link to={`/authors-detail/${a.id}`}>
                                    {a.name}
                                  </Link>
                                </td>
                                <td>
                                  {a.orcid ? (
                                    <a
                                      href={`https://orcid.org/${a.orcid}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {a.orcid}
                                    </a>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2" className="text-center">
                                Yazar bilgisi bulunamadı.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            {/* /Publishers */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorsPublisher;
